module.exports = __webpack_public_path__ + "503137082345ccdf036b2df7eaee96c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/netflix_2022_chart.png
// module id = 1702
// module chunks = 0